import { FC, useEffect, useState } from "react";
import {
  useAlertStore,
  usePopupStore,
  useThemeStore,
  useUserStore,
} from "../../../../../stores";
import styles from "../styles";
import { Column } from "../../../../../components/containers";
import { PopupBack, PopupClose } from "../../../../../popup";
import UserProfilePopup from "../user-profile-popup";
import { UserProps, UserStatus } from "../../types";
import { FileInput, TextInput } from "../../../../../components/inputs";
import { Button } from "../../../../../components/buttons";
import { UserApi } from "../../../../../api";

const UserSelfEditPopup: FC = () => {
  const theme = useThemeStore((s) => s.theme);
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const user = useUserStore((s) => s.user);
  const pushAlert = useAlertStore((s) => s.pushAlert);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxWidth: 430,
        background: theme.background,
        height: "100%",
        maxHeight: 605,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [files, setFiles] = useState<FileList | null>(null);
  const [fullname, setFullname] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const onUpdate = (): void => {
    if (!files && !fullname)
      return pushAlert(
        "لطفا مطمئن شوید که فیلدها به درستی پر شده اند",
        "error"
      );

    setLoading(true);
    UserApi.updateSelf(fullname, files ? files[0] : null)
      .then(() => {
        setPopupBody(null);
        pushAlert("عملیات موفقیت آمیز");
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Column style={styles.userPopupBase}>
      <PopupClose />
      <PopupBack
        props={{ ...(user as UserProps), status: UserStatus.Online }}
        Component={UserProfilePopup}
      />
      <Column style={styles.userPopupContainer} gap={15}>
        <FileInput
          label="عکس پروفایل"
          value={files}
          setValue={setFiles}
          background={theme.overlay}
        />
        <TextInput
          label="نام و نام خانوادگی"
          value={fullname}
          setValue={setFullname}
          background={theme.overlay}
          inputProps={{ placeholder: user?.fullname || "" }}
        />
        <Button
          loading={loading}
          onClick={onUpdate}
          background={theme.primary}
          color={theme.textOnprimary}
        >
          ثبت
        </Button>
      </Column>
    </Column>
  );
};

export default UserSelfEditPopup;
